export default {
  author: 'Origin',
  name: 'Origin',
  cookies: {
    lang: 'origin_lang',
  },
  locale: ['fr', 'en'],
  loader: true,
  mode: '',
  prefixRoute: false,
  cms: true,
  ua_code: {
		global: 'UA-32257069-1',
    project: 'UA-42015401-44',
  },
  onfWebsite: {
    dev: {
      fr: 'dev.experienceparlement.ca',
      en: 'dev.experienceparliament.ca'
    },
    prod: {
      fr: 'www.experienceparlement.ca',
      en: 'www.experienceparliament.ca'
    }
  }
}
